// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"c352ae88","460":"3460862f","625":"9053c235","899":"4f659159","905":"cf5a8057"}[chunkId] + ".chunk.js";
};